import { ICommand } from "./ICommand";
import { AbstractEntityCommand } from "./AbstractEntityCommand";

export class EntityCommand<TSource, TEntity, TCommand extends ICommand<TEntity> = ICommand<TEntity>> extends AbstractEntityCommand<TSource, TEntity, TCommand> implements ICommand<TSource> {
  constructor(private readonly _toEntity: (s: TSource) => TEntity, command: TCommand) {
    super(command);
  }

  protected toEntity(source: TSource): TEntity {
    return this._toEntity(source);
  }
}
